function removeItemFromCart(key) {
  // Call your changeItem function here
  changeItem(key, "0").then(
    function (cart) {
      const parsedCart = JSON.parse(cart);
      const wrapper = document.querySelector(".site-header__drawer-animate");
      if (parsedCart.status === 422) {
        alert(parsedCart.message);
      } else {
        if (parsedCart.item_count > 0) {
          wrapper.classList.remove("is-empty");
        } else {
          wrapper.classList.add("is-empty");
        }
      }

      buildCart();

      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: {
            cart: parsedCart,
          },
        })
      );
    }.bind(cartDrawerForm)
  );
}

function buildCart() {
    return getCartProductMarkup().then(
      cartDrawerForm.cartMarkup.bind(cartDrawerForm)
    );
}
